import { logger } from '@lusha/client-logger';
import { PLATFORM } from '@lusha/source-platforms';
import { reportClientEvent } from '@lusha-growth/bi-client-sdk';

import { PLUGIN_TEAM_NAME } from './eventsSchemaVersions';

const DNC_EVENT_NAME = 'dnc_contact_viewed';

export const reportDncContactViewedClientEvent = ({ uniqueSearchId, subPlatform, pageUrl, numOfContactsWithDncPhone, numOfContactsWithOnlyDncPhones, isBulkSearch }) => {
  reportClientEvent({
    teamName: PLUGIN_TEAM_NAME,
    isLoggedIn: true,
    metadata: {
      eventType: DNC_EVENT_NAME,
      platform: PLATFORM.PLUGIN,
      eventValue: numOfContactsWithDncPhone?.toString(),
      eventExternalKey: uniqueSearchId?.toString(),
      eventPageStateInt: numOfContactsWithOnlyDncPhones,
      eventAdditionalInfo: { isBulkSearch },
      subPlatform,
      pageUrl,
    },
  }).catch(e => {
    logger.error('failed to send dnc_viewed_event', e);
  });
};
